/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tolerance_Band_FromInputs */

const en_tolerance_band_from = /** @type {(inputs: Tolerance_Band_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From units`)
};

/**
* | output |
* | --- |
* | "From units" |
*
* @param {Tolerance_Band_FromInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const tolerance_band_from = /** @type {((inputs?: Tolerance_Band_FromInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tolerance_Band_FromInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_tolerance_band_from(inputs)
});